export { default as UserGroupIcon } from './UserGroupIcon';
